export const DISPLAY_NAME_MAX_LENGTH = 255;

/** Letters (any language), numbers, and spaces — no special characters. */
export const DISPLAY_NAME_ALLOWED_RE = /^[\p{L}\p{M}\p{N} ]+$/u;

export function normalizeDisplayNameInput(raw: string): string {
  return raw.trim();
}

export function getDisplayNameValidationError(raw: string): string | null {
  const name = normalizeDisplayNameInput(raw);
  if (!name) return 'Name is required.';
  if (name.length > DISPLAY_NAME_MAX_LENGTH) {
    return `Name must be at most ${DISPLAY_NAME_MAX_LENGTH} characters.`;
  }
  if (!DISPLAY_NAME_ALLOWED_RE.test(name)) {
    return 'Name may only contain letters, numbers, and spaces (no special characters).';
  }
  return null;
}

export function validateDisplayName(raw: string): string {
  const error = getDisplayNameValidationError(raw);
  if (error) throw new Error(error);
  return normalizeDisplayNameInput(raw);
}
